import { GLOBAL_MODALS, globalModals } from '@/state/globalSettings';
import { useSetAtom } from 'jotai';

const useWalletModal = () => {
  const setModals = useSetAtom(globalModals);

  return () =>
    setModals({
      [GLOBAL_MODALS.WALLET]: true,
    });
};

export default useWalletModal;
